import './PageTemplate.css';

function PageTemplate({ title, subtitle, children }) {
  return (
    <div className="page-template">
      <header className="page-header">
        <h1>{title}</h1>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </header>
      <div className="page-content">
        {children}
      </div>
    </div>
  );
}

export default PageTemplate;
